import './find-booking-view.scss';
import FindBooking from '../../../components/sections/osb-v3/find-booking/find-booking';

export function FindBookingView() {
    return (
        <div className="osb-v3-find-a-booking">
            <FindBooking />
        </div>
    );
}
